import React, { Fragment, useContext, useEffect, useState, memo } from "react";
import CanvasJSReact from '../../../../modules/env/canvasjs.react';

// Provider
import { AppContext } from "../../../../components/AppProvider";
import { post } from 'axios';
import { compareAsc, format, addDays, addMonths } from 'date-fns';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const interfaceDateFormat = 'yyyyMMdd';

export default memo((props) => {

    const {graphParam} = props;

    let maxRangeBp = graphParam.rangeBp.maxBp;
    let minRangeBp = graphParam.rangeBp.minBp;

    if(maxRangeBp == 0) {
        maxRangeBp = 200;
    } else {
        maxRangeBp = maxRangeBp + 40;
    }

    if(minRangeBp == 0) {
        minRangeBp = 0;
    } else {
        minRangeBp = minRangeBp - 40;
    }

    let options = {
        zoomEnabled: true,
        // exportEnabled: true, 차트 이미지 추출
        height: 300,
        toolTip:{
            shared: true,
            contentFormatter: function (e) {
				var content = " ";
					content += e.entries[0].dataPoint.label;
					content += "<br/>";
					content += "<font color='#61d1bc'>" + e.entries[0].dataSeries.name + ":</font>" + " " + "<strong>" + e.entries[0].dataPoint.y + "</strong>";
				
                    return content;
			}
        },
        axisX: {
            labelAngle: 0,
            // interval: 1,
            // interverType: "day",
        },
        axisY: {
            labelAutoFit: false,
            gridDashType: "dash",
            interval: 20,
            minimum: minRangeBp,
            maximum: maxRangeBp,
            stripLines: [{
                startValue: graphParam.targetBp.minBp,
                endValue: graphParam.targetBp.maxBp,
                color: "#61d1bc",
                opacity: .2
            }] 
        },

        data: [{
            type: "rangeColumn",
            name:"혈압(수축기, 이완기)",
            dataPoints: graphParam.rangeColumn,
            color: "#61d1bc",
        },

        {   // 최대
            type: "line",
            markerSize: 0,
            showInLegend: false,
            lineColor: "#f990c4",
            dataPoints: graphParam.maxLine
        },
        
        {   //최소
            type: "line",
            markerSize: 0,
            showInLegend: false,
            lineColor: "#92bbf3",
            fontColor: "#92bbf3",
            dataPoints: graphParam.minLine
        }
        ]
    }

    return(
        <div style={{marginTop:"7vw"}}>
			<CanvasJSChart options = {options} 
				/* onRef={ref => this.chart = ref} */
			/>
		</div>
    );
})